module.exports = __webpack_public_path__ + "static/img/JACK-DELEAN.92cbeb6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/JACK-DELEAN.jpg
// module id = k/Zp
// module chunks = 0